import mitt from 'mitt';

import type { WithdrawFundsEvents } from '../WithdrawFunds.types';

export const withdrawFundsEmitter = mitt<WithdrawFundsEvents>();
